import { v4 as uuid } from "uuid";
import faker from "faker";
/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    name: "Sony Platinum Wireless Headset",
    image: "/assets/products/headset/vr1.webp",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "headset",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["70% bonanza"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Sony Platinum Wireless Headset",
    image: "/assets/products/headset/vr2.webp",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: false,
    fastDelivery: true,
    material: "Rosewood",
    category: "headset",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["Deal of the day"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Sony Platinum Wireless Headset",
    image: "/assets/products/headset/vr3.webp",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "headset",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["70% bonanza"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Sony Platinum Wireless Headset",
    image: "/assets/products/headset/vr4.webp",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "headset",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["Deal of the day"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Sony Platinum Wireless Headset",
    image: "/assets/products/headset/vr5.webp",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "headset",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["70% bonanza"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Sony Platinum Wireless Headset",
    image: "/assets/products/headset/vr6.webp",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "headset",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["Deal of the day"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Sony Platinum Wireless Headset",
    image: "/assets/products/headset/vr7.webp",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "headset",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["70% bonanza"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Sony Platinum Wireless Headset",
    image: "/assets/products/headset/vr8.webp",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "headset",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["Deal of the day"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Sony Platinum Wireless Headset",
    image: "/assets/products/headset/vr1.webp",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "headset",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["70% bonanza"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Gaming Zone Wall sticker",
    image: "/assets/products/sticker/sticker1.webp",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "sticker",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["70% bonanza"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Gaming Zone Wall sticker",
    image: "/assets/products/sticker/sticker2.webp",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "sticker",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["Deal of the day"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Gaming Zone Wall sticker",
    image: "/assets/products/sticker/sticker3.webp",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "sticker",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["70% bonanza"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Nintendo Switch V3 With White Joy Con's (Nintendo)",
    image: "/assets/products/gaming/gaming1.jpg",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "gaming",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["Deal of the day"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Nintendo Switch V3 With White Joy Con's (Nintendo)",
    image: "/assets/products/gaming/gaming2.jpg",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: false,
    fastDelivery: true,
    material: "Rosewood",
    category: "gaming",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["70% bonanza"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Nintendo Switch V3 With White Joy Con's (Nintendo)",
    image: "/assets/products/gaming/gaming3.jpg",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "gaming",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["Deal of the day"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Nintendo Switch V3 With White Joy Con's (Nintendo)",
    image: "/assets/products/gaming/gaming4.jpg",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "gaming",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["70% bonanza"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Nintendo Switch V3 With White Joy Con's (Nintendo)",
    image: "/assets/products/gaming/gaming5.webp",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "gaming",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["Deal of the day"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
  {
    _id: uuid(),
    name: "Nintendo Switch V3 With White Joy Con's (Nintendo)",
    image: "/assets/products/gaming/gaming6.png",
    price: faker.commerce.price(),
    quantity: 1,
    inStock: true,
    fastDelivery: true,
    material: "Rosewood",
    category: "gaming",
    ratings: faker.random.arrayElement([1, 2, 3.5, 4, 5]),
    offer: ["70% bonanza"],
    brand: "gibson",
    description:
      "literature in the form of prose, especially novels, that describes imaginary events and people",
  },
];

// faker.seed(123);

// export const products = [...Array(50)].map((item) => ({
//   id: faker.random.uuid(),
//   name: faker.commerce.productName(),
//   image: faker.random.image(),
//   price: faker.commerce.price(),
//   material: faker.commerce.productMaterial(),
//   brand: faker.lorem.word(),
//   inStock: faker.random.boolean(),
//   fastDelivery: faker.random.boolean(),
//   ratings: faker.random.arrayElement([1, 2, 3, faker.random.arrayElement([1, 2, 3.5, 4, 5]), 5]),
//   offer: faker.random.arrayElement(["70% bonanza", "Deal of the day"]),
//   idealFor: faker.random.arrayElement([
//     "Men",
//     "Women",
//     "Girl",
//     "Boy",
//     "Senior",
//   ]),
//   level: faker.random.arrayElement([
//     "beginner",
//     "amateur",
//     "intermediate",
//     "advanced",
//     "professional",
//   ]),
//   color: faker.commerce.color(),
// }));
export const offerData = ["Deal of the day", "70% bonanza"];
